 export enum ParametrageModuleEnum {
MOD_ABSENCE = 0,
PST = 1,
DSN_TEST = 2,
DSN = 3,
GENERAL = 4,
DPAE = 5,
GED = 6,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/ParametrageModuleEnum.ts